import { Component } from '@angular/core';

@Component({
  selector: 'app-toggle-switcher-showcase',
  templateUrl: './toggle-switcher-showcase.component.html',
  styleUrls: ['./toggle-switcher-showcase.component.scss']
})
export class ToggleSwitcherShowcaseComponent {
  salesChallenges: boolean = true;
  notifications: boolean = false;
  darkMode: boolean = false;
  maintenance: boolean = true;
  advancedFeatures: boolean = false;

  onToggleChange(label: string, value: boolean): void {
    console.log(`${label} toggled to:`, value);
  }
}
